import * as ExcelJS from "exceljs";
import { Combination } from "../../types";

export const readExcel = async (file: File): Promise<Combination[]> => {
    return new Promise((resolve, reject) => {
        const workbook = new ExcelJS.Workbook();
        const reader = new FileReader();

        reader.onload = async (e: ProgressEvent<FileReader>) => {
            if (e.target === null || e.target.result === null) {
                return;
            }

            const buffer: ArrayBuffer = e.target!.result as ArrayBuffer;

            try {
                // Load the Excel file buffer
                await workbook.xlsx.load(buffer);

                // Assuming the data is in the first worksheet
                const worksheet = workbook.getWorksheet(1);

                if (!worksheet) return;

                // Transform worksheet data into an array of objects
                const data: Combination[] = [];
                worksheet.eachRow({ includeEmpty: false }, (row, rowNumber) => {
                    if (rowNumber === 1) return;

                    const rowData: Partial<Combination> = {};
                    row.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                        switch (colNumber) {
                            // supplier
                            case 1:
                                rowData.supplier = cell.value as string;
                                break;
                            // supplier port
                            case 2:
                                rowData.supplierPort = cell.value as string;
                                break;
                            // service
                            case 3:
                                rowData.service = cell.value as string;
                                break;
                            // line
                            case 4:
                                rowData.line = cell.value as string;
                                break;

                            // arrival
                            case 5:
                                rowData.arrival = cell.value as number;
                                break;

                            // rate
                            case 6:
                                rowData.rate = cell.value as string;
                                break;

                            // port
                            case 7:
                                rowData.port = cell.value as string;
                                break;

                            // warehouse
                            case 8:
                                rowData.warehouse = cell.value as string;
                                break;

                            // item
                            case 9:
                                rowData.item = cell.value as string;
                                break;

                            // quantity
                            case 10:
                                rowData.quantity = cell.value as number;
                                break;
                            // pallets
                            case 11:
                                rowData.pallets = cell.value as number;
                                break;
                            // pallets capacity
                            case 12:
                                rowData.availablePallets = cell.value as number;
                                break;

                            // variable
                            case 13:
                                rowData.variable = cell.value as string;
                                break;
                            // x factor
                            case 14:
                                rowData.factor = cell.value as number;
                                break;

                            // forecast
                            case 15:
                                rowData.forecast = cell.value as number;
                                break;

                            // quarterly avg forecast
                            case 16:
                                rowData.quarterlyAvgForecast = cell.value as number;
                                break;

                            // soh
                            case 17:
                                rowData.soh = cell.value as number;
                                break;

                            // pallet capacity
                            case 18:
                                rowData.palletCapacity = cell.value as number;
                                break;

                            // pallet holding cost
                            case 19:
                                rowData.palletHoldingCost = cell.value as number;
                                break;

                            // doc max
                            case 20:
                                rowData.docMax = cell.value as number;
                                break;

                            // inbound cost
                            case 21:
                                rowData.inboundCost = cell.value as number;
                                break;

                            // outbound cost
                            case 22:
                                rowData.outboundCost = cell.value as number;
                                break;

                            // case margin
                            case 23:
                                rowData.caseMargin = cell.value as number;
                                break;
                        }
                    });
                    data.push({ ...rowData, variableValue: null } as Combination);
                });

                resolve(data);
            } catch (error) {
                reject(error);
            }
        };

        reader.readAsArrayBuffer(file);
    });
};
